import React from 'react';
import '../../../css/login.css';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Control, LocalForm} from 'react-redux-form';

class RegionForm extends React.Component {

    buttonClick(ref) {
        ref.click();
    }

    render() {
        const ControlPassword = Control.password;
        const {redirectEndpoint, username} = this.props;
        const divStyle = {
            display: 'none'
        };

        return (
            <div key="RegionForm_1" style={divStyle}>
                <LocalForm action={redirectEndpoint} method="post" >
                    <div className="wdc-form-field">
                        <ControlPassword model="username" id="username" value={username} />
                    </div>
                    <button className="wdc-btn wdc-btn-primary" ref={ref => this.buttonClick(ref)} autoFocus={true}>Continue</button>
                </LocalForm>
            </div>
        );
    }

}

RegionForm.propTypes = {
    redirectEndpoint: PropTypes.string,
    username: PropTypes.string
};

const mapStateToProps = (state) => {
    return {
        redirectEndpoint: state.login.redirectEndpoint,
        username: state.login.username
    };
};

export default connect(mapStateToProps)(RegionForm);
